/**
 * Directory – Directory & Listing Bootstrap 4 Theme v. 1.4.2
 * Homepage: https://themes.getbootstrap.com/product/directory-directory-listing-bootstrap-4-theme/
 * Copyright 2020, Bootstrapious - https://bootstrapious.com
 */

"use strict";
import "daterangepicker";

$(function () {
  $("input[name='daterange']").daterangepicker({
    autoUpdateInput: true,
    locale: {
      cancelLabel: "Clear", // dates are optional
    },
  });
  // remove default value of today - today
  $("input[name='daterange']").val("");
  $("input[name='daterange']").on("apply.daterangepicker", function (ev, picker) {
    $("input[name='from_date']").val(picker.startDate.format("YYYY-MM-DD"));
    $("input[name='to_date']").val(picker.endDate.format("YYYY-MM-DD"));
  });

  $("input[name='daterange']").on("cancel.daterangepicker", function (ev, picker) {
    $("input[name='daterange']").val("");
  });
});
